// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@store/MobiusOverrides/Link/Link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

export interface USACountryIconStyles {
    link?: InjectableCss;
    flag?: InjectableCss;
}

export const usaCountryIconStyles: USACountryIconStyles = {
    link: {
        css: css`
            padding: ${pxToRem(6, 6, 0)};
        `,
    },
    flag: {
        css: css`
            width: ${pxToRem(48)};
            background: ${getColor("common.background")};
        `,
    },
};

const styles = usaCountryIconStyles;

const USACountryIcon = () => {
    return (
        <Link href="https://www.grimco.com/" alt="Grimco US" {...styles.link}>
            <img
                {...styles.flag}
                src="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAZCAYAAAB3oa15AAAEGklEQVRYhdVWbUxbZRg9tx+0tNBCoXSjYMvG54KOucGYwmAsgQAOlekEl7GxGWTDzZBpnDRZwsz2wy1SScSY6ca+VJzxI2F2xiFbRRE32BAsOigMGNBPykqB0tJec9/41z/EXOmT3JuT3OTNc97znPNcCsnVdLhEBIdzHkzJpAxeAE3TEATxwOdx4ZpfJN8iwsSwz8z9K26wGJDmdoLN4lAUhVO1O/BEkhIMrn4pC8Vb1xFcVvgk9pSkE5y3ORFH9+URnKCSQ3usFFwuB6FiIZpP7UawkM+0TbP9EAWYplZHSlBdloX6Jh1EwXxoqgpQ/4EO3iU/3jlShDPnfyQqaV7Nx+ff9cA4bsP+0kwMGM3o7B2B30+j/UItcjMSWVWAolIO0gVPJ2Ng2AxJiBCR4WIMjdkQo5DC6VqEUMAjt261u5C8RoHRyWl4l3xIWaPAH0YTOBwKKXEKtHXdx7UPa/zbNifSbBLgMbMeuzoc/UNTGJtyYG1sJCLDxDAYzVifpASPy0G3YRyxq8IIwSmbE3weB3ExEdB3GzG/4MXLxRtxTW9Ab3EVh2LZA2SEGKBWylD/WhEqNVcgEgbhyrsVKDvaTG770zN7UXPiKqwOFxo1L6D56y70GMbxRuV2DI5Z8G1bHzlM65mwp/v/cTxbBJgRenP/drRc78GEaQaVpZno+n0Ufw6bsHVTPETBQdDpDUhURyE3Ix4ftfwMuSwElc9n4vS5NmLe1/fk4PQnbdCdPcy+BxgFNqTEwOaYg0opg33ahUWvD9EKKcw2J8kUhVyCCfMMggV8yMLEGH5og1Iuhc9Pw2R1IkEtx63bQ7jx8WF3Xkaij00CPOY1OGqFRCxEzqa1aLysh3vRi0PlWahraAWXS6HiuQySQks+H3LS42F3uGAYNqEwex1R6Hb/GDmsr+SgkMu2B5gRajq+C42XbpIkqqvKx299o7jR+RfKizYiRCzA2au/YEuaGs/kpkKjbSWmr68pxCvHPyMjdP7kblS8dQnaVbTlKTHlZpUAM0LMxo2OkpI0ee9CO1lONeXZ0F68CY/Xh9q9uWj+pgvWaRcOlWfj+44BjDy048WCDcTE/YMmzM65/5c9wGMyPilOgQmTA/o7RsQpI0icdt4bQRCfC2moEL/2PoBzzk2M3NFtxCOXGwnqKNwxjMPjWSKRahiawrzZPr04afGwSoDZA8/mpeIL3V381G3EgZ1boIgMxfWOAezYlkoitUXXg8z1amQ8rkLj5VtQRcvIb4bm/VYI+Fw0vL0TR05+ifv7jslEbHuguqRu9r86bJdKsvCYmM9qClE0I0EAF+9RV+9YIBOg2kVpAa0AZfnqB9cK6GPZFfgeeHCiaXIF9LHsCnwPzN4bWFoBfSy7At4D1N38A4GdQgHtAQB/A8VCxntfm3npAAAAAElFTkSuQmCC"
                alt="https://www.grimco.com/"
            />
        </Link>
    );
};

export default USACountryIcon;
